// Client for My Work (apps/api/src/mywork.ts): what's waiting on the person, what they own and what they finished.
import { request } from "../api";
import { SUITE, findModule } from "../suite";

export type WorkItem = {
  key: string; action: string; title: string; number: string | null;
  app: string; appName: string; area: string;
  detail: string | null; by: string | null; at: string; due: string | null; href: string;
  asked?: boolean; state?: string | null;
};
export type Counts = { waiting: number; asked: number; progress: number; overdue: number; byApp?: Record<string, { area: string; n: number }> };
export type MyWork = { waiting: WorkItem[]; progress: WorkItem[]; done: WorkItem[]; counts: Counts };

export const myWork = {
  all: () => request<MyWork>("GET", "/api/my-work/all"),
  count: () => request<Counts>("GET", "/api/my-work/count"),
};

/** The app's name as the navigation shows it (simple apps are named in the suite, not in Security's catalog). */
export const appNameOf = (w: WorkItem) => findModule(w.app)?.module.name ?? w.appName;
/** The area an item belongs to, for the filter. */
export const areaOf = (w: WorkItem) => w.area || findModule(w.app)?.domain.id || "";
/** What's waiting on the person in each area, from the counts. */
export function waitingByArea(c: Counts | null): Record<string, number> {
  const out: Record<string, number> = {};
  for (const [app, { area, n }] of Object.entries(c?.byApp ?? {})) {
    const id = area || findModule(app)?.domain.id;
    if (id) out[id] = (out[id] ?? 0) + n;
  }
  return out;
}
export const areaName = (id: string) => SUITE.find((d) => d.id === id)?.name ?? (id ? id[0].toUpperCase() + id.slice(1) : "Other");

/** Tell the top bar to count again after something changed (an approval, a step done). */
export const workChanged = () => window.dispatchEvent(new Event("courage:my-work"));
